import { render, staticRenderFns } from "./MiniTable.vue?vue&type=template&id=fe521fc8&scoped=true&"
import script from "./MiniTable.vue?vue&type=script&lang=ts&"
export * from "./MiniTable.vue?vue&type=script&lang=ts&"
import style0 from "./MiniTable.vue?vue&type=style&index=0&id=fe521fc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe521fc8",
  null
  
)

export default component.exports